module.exports = __webpack_public_path__ + "static/media/mesh-group.0522d52a.svg";